import { ROLE_EDITOR } from "../../utils/helper";
import {
  resetArcGisUser_actionType,
  resetAuthUser_actionType,
  setArcGisUser_actionType,
  setAuthUser_actionType,
  setEnterpriseUser_actionType,
  setUserRole_actionType,
} from "../constants";

const initialState = {
  authUser: null,
  arcGisUser: null,
  enterpriseUser: null,
  userRole: null,
};

// const initialState = false
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case setAuthUser_actionType: {
      const { payload } = action;
      return {
        ...state,
        authUser: payload,
      };
    }
    case resetAuthUser_actionType: {
      return {
        ...state,
        authUser: initialState.authUser,
      };
    }
    case setArcGisUser_actionType: {
      const { payload } = action;
      return {
        ...state,
        arcGisUser: payload,
        userRole: payload ? ROLE_EDITOR : null,
      };
    }
    case resetArcGisUser_actionType: {
      return {
        ...state,
        arcGisUser: initialState.arcGisUser,
        userRole: null,
      };
    }
    case setUserRole_actionType: {
      return {
        ...state,
        userRole: action.payload,
      };
    }
    case setEnterpriseUser_actionType: {
      return {
        ...state,
        enterpriseUser: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default userReducer;
